import { createStandardAction } from "typesafe-actions";

export const saveModalEvent = createStandardAction("@@utils/SAVE_MODAL_EVENT")();